import {Tabs, Tab, Grid} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import React from 'react';
import {TGT_DOW, TGT_MONTH, TGT_YEAR, TGT_YEAR_CUMULATIVE} from './StatsDow.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_OTHER, TAB_OBS_COUNT} from './StatsCommon.js';
import StatsDow from './StatsDow.js';

export const TAB_DOW		= 0
export const TAB_MONTH2		= 1
export const TAB_YEAR2		= 2
export const TAB_YEAR_CUMULATIVE= 3

const StatsObsCount = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const handleTabChange = (event, tab) => {
		gStorage.stats.setObsList(null);
		gStorage.stats.setObsCntTab(tab);
	}

	if (gStorage.stats.tab !== TAB_OTHER || gStorage.stats.other_tab !== TAB_OBS_COUNT)
		return null;

	return (
		<>
			<Grid container direction="row" justifyContent="center" spacing={0} columns={1}>
				<Tabs
					value={gStorage.stats.obs_cnt_tab}
					onChange={handleTabChange} 
					align={'center'}
					indicatorColor="primary"
					textColor="primary"
					scrollButtons="auto"
					variant="scrollable"
					sx={{mb: 1}}>
					<Tab label={t('stats.weekday')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.monthly')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.yearly')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.cumulative')} disabled={!gStorage.conn.online}/>
				</Tabs>
			</Grid>

			<StatsDow tgt={TGT_DOW} />
			<StatsDow tgt={TGT_MONTH} />
			<StatsDow tgt={TGT_YEAR} />
			<StatsDow tgt={TGT_YEAR_CUMULATIVE} />
		</>
	);
});

export default StatsObsCount;
